import { render, staticRenderFns } from "./policy_mgt.vue?vue&type=template&id=7fc26638&scoped=true"
import script from "./policy_mgt.vue?vue&type=script&lang=js"
export * from "./policy_mgt.vue?vue&type=script&lang=js"
import style0 from "./policy_mgt.vue?vue&type=style&index=0&id=7fc26638&prod&lang=less"
import style1 from "./policy_mgt.vue?vue&type=style&index=1&id=7fc26638&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc26638",
  null
  
)

export default component.exports